import { useState } from "react";
import {
  Box,
  Checkbox,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { QuestionCard, itemStyle } from "../mobilePreview.style";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

type Props = {
  currentQuestion: any;
};

const CheckboxFieldPreview = ({ currentQuestion }: Props) => {
  const { choices } = currentQuestion;
  const [selected, setSelected] = useState<Record<string, boolean>>({});

  const handleToggle = (id: string) => {
    setSelected((prev: any) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <Box sx={QuestionCard}>
        <Stack>
          {choices.map((choice: any, index: number) => (
            <Box key={choice?.id}>
              <Box sx={itemStyle}>
                <Typography variant="subtitle1">{choice.label}</Typography>
                <Checkbox
                  checked={!!selected[choice?.value]}
                  onChange={() => handleToggle(choice?.value)}
                  icon={
                    <RadioButtonUncheckedIcon
                      sx={{ fontSize: 24, color: "gray" }}
                    />
                  }
                  checkedIcon={
                    <CheckCircleIcon sx={{ fontSize: 24, color: "primary" }} />
                  }
                />
              </Box>
              {choice?.isOther && selected[choice?.value] && (
                <TextField
                  fullWidth
                  value={choice?.remarkText}
                  placeholder="Type here"
                  sx={{ mb: 2 }}
                />
              )}
              {index !== choices.length - 1 && <Divider />}
            </Box>
          ))}
        </Stack>
      </Box>
    </>
  );
};
export default CheckboxFieldPreview;
